import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { withRouter/*, Redirect*/ } from 'react-router-dom'
import { authorizeBSRS } from '../actions'
import Loadable from 'Features/ui/components/Loadable'
// import { getServiceToken } from 'Lib'
import { setError } from '../../ui/actions'

const AsyncLoginBSRSForm = Loadable({
	loader: () => import(/* webpackChunkName: "LoginBSRSForm" */ './LoginBSRSForm')
})

class LoginBSRS extends PureComponent {

	render() {
		return (
			<AsyncLoginBSRSForm
				onSubmit={this.props.authorizeProfile}
			/>
		)
	}
}
export default compose(
	withRouter,
	connect(
		(state, props) => ({
		}),
		(dispatch, { history }) => ({
			authorizeProfile(value) {
				// dispatch(authorizeProfile(value))
				dispatch(authorizeBSRS(value))
			},
			setError(hasError, errorCode) {
				dispatch(setError(hasError, errorCode))
			}
		})
	),
)(LoginBSRS)


// WEBPACK FOOTER //
// ./src/features/auth/components/LoginBSRS.js